import * as React from 'react';
import './index.scss';
interface Iprops {
    product: {
        img: string;
        product_img?: string; // 售后迁中台，新字段，用于代替 img 字段
        product_name: string;
        spec_desc: string;
        disabled?: boolean;
        disabledReason?: string;
        bottom?: React.ReactNode;
    };
    className?: string;
    titleColor?: string;
}
export function Card(props: Iprops) {
    const { product, className, titleColor } = props;

    const productImg = product.img || product.product_img;

    return (
        <>
            <div className={`afg_card${className ? ` ${className}` : ''}`}>
                <div className="afg_card__img">
                    <div
                        className="afg_card__img__pic"
                        style={{
                            backgroundImage: `url(${productImg})`
                        }}
                    />
                    <div className="afg_card__img__shadow" />
                </div>
                <div className="afg_card__mid">
                    <div
                        className={`afg_card__mid-title${
                            product.disabled ? ' afg_card__mid-disabled' : ''
                        }`}
                        style={titleColor ? { color: titleColor } : {}}
                    >
                        <div className="afg_card__mid-name">{product.product_name}</div>
                    </div>
                    <div className="afg_card__mid-spec">
                        <span>{product.spec_desc}</span>
                    </div>
                    {product.disabledReason && (
                        <div className="afg_card__mid-reason">
                            <span>{product.disabledReason}</span>
                        </div>
                    )}
                </div>
            </div>
            {product.bottom || null}
        </>
    );
}

export default Card;
